import React from 'react';
import PoliciesForm from '../../Policies/ExperiencePolicies';

const ExperiencePolicies = () => {
    return <PoliciesForm />;
};

export default ExperiencePolicies;
